/**
 * Veeam Service Provider Console REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OAuth2Credential } from './oAuth2Credential';
import { SmtpSettingsServerCertificate } from './smtpSettingsServerCertificate';
import { SmtpSettingsPasswordCredential } from './smtpSettingsPasswordCredential';


export interface SmtpSettings { 
    /**
     * SMTP server URI containing protocol, host and port.
     */
    serverAddress: string;
    /**
     * Type of secure socket comminucation used to connect to an SMTP server.
     */
    tlsMode: SmtpSettingsTlsMode;
    /**
     * Connection timeout.
     */
    timeout: string;
    passwordCredential?: SmtpSettingsPasswordCredential | null;
    /**
     * Credentials for OAuth 2.0 authentication to an SMTP server.
     */
    oAuth2Credential?: OAuth2Credential | null;
    /**
     * Server X509 certificate hex-encoded hash in the `<hash-algorithm>:<hash-hex>` format.
     */
    exclusivelyAcceptedCertificateHash?: string | null;
    serverCertificate?: SmtpSettingsServerCertificate | null;
}
export enum SmtpSettingsTlsMode {
    Auto = 'auto',
    None = 'none',
    SslOnConnect = 'sslOnConnect',
    StartTls = 'startTls',
    StartTlsWhenAvailable = 'startTlsWhenAvailable'
};



